import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../Header/constants';
import { ReactComponent as OccasiaLogoIcon } from '../icons/occasia-logo-icon.svg';
import { ReactComponent as InstagramIcon } from '../icons/instagram-icon.svg';
import { ReactComponent as LinkedInIcon } from '../icons/linkedin-icon.svg';
import './OrganizerFooter.css';

const FOOTER_LINKS = [
  { label: 'About us', to: '/about' },
  { label: 'Blog', to: '/blog' },
  { label: 'Terms of use', to: '/terms' },
  { label: 'Privacy Policy', to: '/privacy' },
];

const OrganizerFooter = () => (
  <footer className="org-footer">
    <div className="org-footer-inner">
      <div className="org-footer-left">
        <Link to={ROUTES.PROFILE} className="org-footer-logo-link" aria-label="Occasia home">
          <OccasiaLogoIcon className="org-footer-logo-mark" aria-hidden="true" />
        </Link>
        <nav className="org-footer-nav" aria-label="Footer">
          {FOOTER_LINKS.map(({ label, to }) => (
            <Link key={to} to={to} className="org-footer-link">
              {label}
            </Link>
          ))}
        </nav>
      </div>
      <div className="org-footer-social">
        <a
          href="https://www.instagram.com/occasia.ofcl/"
          target="_blank"
          rel="noopener noreferrer"
          className="org-footer-social-link"
          aria-label="Instagram"
        >
          <InstagramIcon className="org-footer-social-icon" />
        </a>
        <a
          href="https://www.linkedin.com/company/occasia/about/"
          target="_blank"
          rel="noopener noreferrer"
          className="org-footer-social-link"
          aria-label="LinkedIn"
        >
          <LinkedInIcon className="org-footer-social-icon" />
        </a>
      </div>
    </div>
  </footer>
);

export default OrganizerFooter;
